import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function StaffLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (user) navigate("/staf", { replace: true });
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full px-4 py-3 rounded-xl border border-sage-200 bg-white/70 focus:outline-none focus:ring-2 focus:ring-forest/30";
  return (
    <div className="min-h-screen bg-cream grid place-items-center px-4">
      <form onSubmit={submit} className="card-paper w-full max-w-sm p-8 rise" data-testid="staff-login-form">
        <Link to="/"><Logo /></Link>
        <h1 className="font-serif font-semibold text-2xl mt-8">Masuk Staf</h1>
        <p className="text-sm text-muted2 mt-1">Kelola pesanan dan menu kafe.</p>
        <div className="space-y-3 mt-6">
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className={input} data-testid="staff-login-username-input" />
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Kata sandi" className={input} data-testid="staff-login-password-input" />
        </div>
        {error && <p className="text-sm text-red-700 mt-3" data-testid="staff-login-error">{error}</p>}
        <button disabled={busy} className="btn-forest w-full py-3.5 mt-6 flex items-center justify-center gap-2" data-testid="staff-login-submit-button">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Masuk
        </button>
      </form>
    </div>
  );
}
